"use client";

import { useEffect, useState } from "react";
import { APP_RESUME_EVENT } from "./appLifecycle";

export function useAppResumeRevision() {
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    const refresh = () => setRevision(current => current + 1);
    window.addEventListener(APP_RESUME_EVENT, refresh);
    return () => window.removeEventListener(APP_RESUME_EVENT, refresh);
  }, []);

  return revision;
}
